import { render, staticRenderFns } from "./insufficient_funds.vue?vue&type=template&id=d6a16580&"
import script from "./insufficient_funds.vue?vue&type=script&lang=js&"
export * from "./insufficient_funds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports